var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"m19.978 7.602-10 10a.937.937 0 0 1-1.328 0l-4.375-4.375a.94.94 0 1 1 1.328-1.328l3.712 3.711 9.337-9.335a.94.94 0 1 1 1.328 1.328z"}})])
}
var staticRenderFns = []

export default { render: render }